export default "__VITE_PUBLIC_ASSET__809e5df4__"